var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcOutlineLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 100,
    viewBox: "0 0 93 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.0859 95.6052C37.7661 95.6052 30.959 88.7981 30.959 80.4783H61.2129C61.2129 88.7981 54.4057 95.6052 46.0859 95.6052Z",
    fill: "#FCE38A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9193 38.7301V27.0001H42.2526V38.7301C25.0026 40.6467 11.5859 55.2517 11.5859 72.9617C11.5859 77.2167 15.0359 80.6667 19.2909 80.6667H30.7526C30.7526 89.1384 37.6143 96.0001 46.0859 96.0001C54.5576 96.0001 61.4193 89.1384 61.4193 80.6667H72.8809C77.1359 80.6667 80.5859 77.2167 80.5859 72.9617C80.5859 55.2517 67.1693 40.6467 49.9193 38.7301ZM46.0859 88.3334C41.8693 88.3334 38.4193 84.8834 38.4193 80.6667H53.7526C53.7526 84.8834 50.3026 88.3334 46.0859 88.3334ZM46.0859 73.0001H19.2526C19.2526 58.2034 31.2893 46.1667 46.0859 46.1667C60.8826 46.1667 72.9193 58.2034 72.9193 73.0001H46.0859Z",
    fill: "#EEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2526 27.0001H49.9193V0H42.2526V27.0001Z",
    fill: "#EEEEEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 7.95898,
    y: 57.4783,
    width: 76.2539,
    height: 61.127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.988235 0 0 0 0 0.890196 0 0 0 0 0.541176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlineLight);
export default __webpack_public_path__ + "static/media/ic_outline-light.28010177.svg";
export { ForwardRef as ReactComponent };